import { userId } from '../fixture-ids';

// Neither action identifies a record: entity: null, renderMode: 'keyValue', and no predecessor
// lookup. `userId` duplicates audit_logs.user_id and carries no record identity of its own.
export const authEntries = {
  AUTH_LOGGED_IN: {
    entity: null,
    identity: 'event',
    renderMode: 'keyValue',
    createsRecord: false,
  },
  // No current writer exists (sc-40476 removed the only one, 2026-09-10) -- this is the one and
  // only shape this action has ever had.
  AUTH_LOGGED_OUT: {
    entity: null,
    identity: 'event',
    renderMode: 'keyValue',
    createsRecord: false,
  },
};

export const authFixtures = {
  AUTH_LOGGED_IN: { action: 'AUTH_LOGGED_IN', debugData: { userId, context: 'AUTH0' } },
  AUTH_LOGGED_OUT: { action: 'AUTH_LOGGED_OUT', debugData: { userId, context: 'AUTH0' } },
};
